import { render } from "./Result.vue?vue&type=template&id=1a7bb2c4&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=1a7bb2c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a7bb2c4"

export default script